<div class="slider">
    <img src="assets/images/arrow.png" (click)="scrollSide('right')"  class="arrow prev" [ngClass]="scroll2.scrollLeft >= 0?'hide' :''"/>
    
    <div class="scroll" #scroll (scroll)="onScroll()">
        <ul class="tags">
            
            <li *ngFor="let tag of tags">
                <tag [tag]="tag">
                   
                </tag>
            </li>
        </ul>
    </div>

    <img src="assets/images/arrow.png" (mousedown)="scrollSide('left')" class="arrow next"
    [ngClass]="scroll2.scrollLeft-1 <= 0 - scroll2.scrollWidth + scroll2.offsetWidth&&finishedLoading?'hide' :''"/>
</div>
